/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	MetaAdStructureGetMetaAdCampaignByCampaignIdPathParams,
	MetaAdStructureGetMetaAdCampaignByCampaignIdResponse,
} from '../types/MetaAdStructureGetMetaAdCampaignByCampaignId'

/**
 * GET /meta/ad-campaign/campaign/:campaignId
 * @see backend/nexus/modules/MetaAd/Http/Controllers/MetaAdStructureController.php MetaAdStructureController::getMetaAdCampaignByCampaignId
 */
export async function metaAdStructureGetMetaAdCampaignByCampaignId(
	campaignId: MetaAdStructureGetMetaAdCampaignByCampaignIdPathParams['campaignId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<MetaAdStructureGetMetaAdCampaignByCampaignIdResponse>> {
	return axiosInstance.get(`/meta/ad-campaign/campaign/${campaignId}`, config)
}
